import { BaseTitolo } from '@lucan/base-ui'

export default function Titolone(props) {
  const { children, ...rest } = props
  
  return <BaseTitolo variant="h1" {...rest}>{children}</BaseTitolo>
}
